import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output
} from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';

import { Project } from '@core/models/project';
import { DataCySlugPipe } from '@shared/pipes/data-cy-slug.pipe';
import { SortPipe } from '@shared/pipes/sort.pipe';

@Component({
  selector: 'app-project-picker',
  templateUrl: './project-picker.component.html',
  styleUrls: ['./project-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    NgClass,

    MatButton,
    MatIcon,
    MatMenu,
    MatMenuItem,
    MatMenuTrigger,

    DataCySlugPipe,
    SortPipe
  ]
})
export class ProjectPickerComponent {
  readonly projects = input.required<Project[]>();
  readonly selectedProjectId = input.required<string>();
  readonly disabled = input.required<boolean>();

  readonly selected = output<Project>();

  readonly selectedProject = computed(() =>
    this.projects().find(x => x.id === this.selectedProjectId())
  );

  onProjectChange(project: Project): void {
    this.selected.emit(project);
  }

  onMenuTriggered(): void {
    setTimeout(() => {
      const selectedProject = document.getElementsByClassName(
        'selectedProject'
      )[0] as HTMLElement;

      selectedProject?.scrollIntoView({ block: 'start' });
    });
  }
}
